import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useMutation } from "@apollo/react-hooks";
import uniqid from "uniqid";
import $ from "jquery";
import logo from "../../assets/white-logo.svg";
import { setUser, setUserInfo } from "../../lib/session";
import { USER_REGISTER } from "../../lib/graphql/mutations";
import { PayPalButton } from "react-paypal-button-v2";
import scriptLoader from "react-async-script-loader";

const Register = props => {
  const { history, track, isScriptLoaded, isScriptLoadSucceed } = props;

  const [userRegister, { data, error }] = useMutation(USER_REGISTER);
  const price = 87;

  if (!error) {
    let account = "";
    const { userRegister: { authToken, user: { username } = {} } = {} } =
      data || {};

    if (authToken && username) {
      account = {
        username,
        type: "parent",
        token: authToken,
        home: "/children_teens"
      };
      if (account) {
        setUser(account);
        track("login", "user", ({ data }) => {
          const { trackActivity: { user: userData } = {} } = data || {};
          setUserInfo("data", userData);
          history.push(account.home);
          window.location.reload();
        });
      }
    }
  }

  const resize = () => {
    setWinWidth($(window).width() - 10);
  };

  const [isLoaded, setLoaded] = useState(false);
  const [winWidth, setWinWidth] = useState(0);

  const createOrder = (data, actions) => {
    return actions.subscription.create({
      plan_id: process.env.REACT_APP_PAYPAL_PLAN_ID
    });
  };

  useEffect(() => {
    if (!isLoaded) {
      if (isScriptLoadSucceed) {
        setLoaded(true);
      }
    }
  }, [isScriptLoaded, isScriptLoadSucceed, isLoaded]);

  useEffect(() => {
    resize();
    window.addEventListener("resize", resize);
    $("html, body")
      .stop()
      .animate({ scrollTop: 0 }, 500);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div className="register">
      <div className="imageContainer hero-container secondary">
        <div className="logoContainer">
          <img src={logo} alt="logo" className="logo" />
        </div>
        <div className="gradient" />
      </div>
      <div className="register-container">
        <div>
          <ul>
            <li>Create a bubble of calm</li>
            <li>Make bedtime stress-free</li>
            <li>Watch attention-span improve</li>
            <li>Enjoy this magical time as a family</li>
          </ul>
        </div>
        <div>
          <p>
            Try 7 Days for <b>FREE</b>
            <br />
            Then, <b>{`${price} annually`}</b>
          </p>
        </div>
        {error && (
          <div className="register-error">
            You cannot login with the credentials you provided.
          </div>
        )}
        {isLoaded && (
          <PayPalButton
            // shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
            options={{ vault: true }}
            createSubscription={(data, actions) =>
              actions.subscription.create({
                plan_id: process.env.REACT_APP_PAYPAL_PLAN_ID
              })
            }
            onApprove={(data, actions) =>
              actions.subscription.get().then(details => {
                const mutationId = uniqid();

                const {
                  payer: {
                    email_address,
                    name: { given_name, surname } = {}
                  } = {}
                } = details;

                userRegister({
                  variables: {
                    email: email_address,
                    firstName: given_name,
                    lastName: surname,
                    mutationId
                  },
                  errorPolicy: "all"
                });

                alert(
                  "Transaction completed by " +
                    given_name +
                    ". Check your email: " +
                    email_address +
                    " for login information"
                );
              })
            }
          />
        )}
      </div>
    </div>
  );
};

export default scriptLoader(
  `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&disable-funding=paylater`
)(Register);
